import { useState } from "react";
import { FiChevronUp,FiChevronDown } from "react-icons/fi";
import { motion } from 'framer-motion';
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";

const Accordion = ({data}) => {
    // const [accordion, setAccordion] = useState([
    //     {
    //         question: "Accredited by",
    //         answer:
    //             `Malaysian Qualifications Agency (MQA)
    //             Malaysian Qualifications Register (MQR)
    //             Engineering Accreditation Council (EAC)`,
    //         open: true
    //     },
    //     {
    //         question: "Approved & Licensed By",
    //         answer: "",
    //         open: false
    //     },
    //     {
    //         question:
    //             "Recognized By",
    //         answer: "",
    //         open: false
    //     }
    // ]);
    const [accordion,setAccordion] = useState(
        data?.map((faq,index) => {
            return {
                question:faq?.content?.properties?.label,
                answer:DecodeHtml({html:faq?.content?.properties?.content.markup}),
                open:index === 0 ? true :false
            }
        })
    )
    const toggleAccordion = index => {
        setAccordion(
            accordion.map((faq, i) => {
            if (i === index) {
              faq.open = !faq.open;
            } else {
              faq.open = false;
            }
    
            return faq;
          })
        );
      };
    return (
        <div className="w-full md:w-5/6 lg:w-[27rem] h-fit bg-white rounded-2xl border-2 border-stone-300  py-8 flex flex-col gap-5" >
            {
                accordion?.map((faq, index) => (
                    <div key={index} className={`w-full flex flex-col gap-2 p-4 py-6 ${index < accordion.length-1 && "border-b"}`}>
                        <div className="flex items-center justify-between" >
                            <motion.span 
                            animate={
                                {
                                    fontSize:faq.open ? "24px" : "18px",
                                    lineHeight:faq.open ? "32px" : "28px",
                                    color:faq.open ?"#0039CB":"#040430"
                                }
                            }
                            transition={{
                                type:'spring',
                                stiffness:300,
                                damping:20
                            
                            }}
                            className="text-slate-900  text-lg font-semibold">{faq.question}</motion.span>
                            <span className="text-slate-900 text-2xl font-bold cursor-pointer z-20" onClick={() => toggleAccordion(index)}>{faq.open ? <FiChevronUp /> : <FiChevronDown />}</span>
                        </div>
                        <motion.div 
                        initial={
                            {
                                opacity:0,
                                height:0
                            }
                        }
                        animate={faq.open ? {opacity:1,height:"fit-content"} : {opacity:0,height:0}}
                        transition={{
                            type:'spring',
                            stiffness:300,
                            damping:20
                        
                        }}
                        className={`flex flex-col gap-2 ${faq.open ? "z-[1]":"z-[-1]"}`}>
                            <span className="text-sky-600 text-xl font-semibold underline underline-offset-4 cursor-pointer">{faq.answer}</span>
                        </motion.div>
                    </div>
                ))
            }
        </div>
    )
}
Accordion.propTypes = {
    data: PropTypes.array
}
export default Accordion